export default __webpack_public_path__ + "static/media/submission-background.4ecc4797.jpg";